import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
  href?: string;
  onClick?: React.MouseEventHandler;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-[#A54D1F]',
    secondary: 'bg-forest text-white hover:bg-[#1E380F]',
    outline: 'bg-transparent border-2 border-terracotta text-terracotta hover:bg-terracotta hover:text-white'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClass = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileTap={{
      scale: 0.98
    }} className={combinedClass} onClick={onClick} data-id="element-159">
        {children}
      </motion.a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={combinedClass} {...props} data-id="element-160">
      {children}
    </motion.button>;
}